import React from "react";
import styled from "styled-components";
import { color } from "styled-system";

import { H6 } from "../headings";
import Text from "../text";

import {
  AppleSvg,
  BikeSvg,
  ClinicSvg,
  HouseSvg,
  LightbulbSvg,
  SeniorSvg,
  SpeechBubbleSvg,
  TreeSvg,
  TrophySvg
} from "./svgs";

const Wrapper = styled.aside`
  width: 33%;
  @media (max-width: 64rem) {
    position: relative;
    z-index: 0;
    width: 100%;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: -7.5vw;
      left: -7.5vw;
      z-index: -1;
      padding-bottom: 34%;
      ${color};
    }
  }
`;

const AbrioFact = ({ type, number, children, color }) => (
  <Wrapper bg={color}>
    <div
      css={`
        position: relative;
        margin-top: calc(-50% - 64px);
        margin-bottom: 32px;
        &::before {
          content: "";
          display: block;
          padding-bottom: 100%;
        }
        @media (max-width: 64rem) {
          width: 33%;
          margin-top: 4%;
        }
      `}
    >
      {type === "Apple" && <AppleSvg />}
      {type === "Bike" && <BikeSvg />}
      {type === "Clinic" && <ClinicSvg />}
      {type === "House" && <HouseSvg />}
      {type === "Lightbulb" && <LightbulbSvg />}
      {type === "Senior" && <SeniorSvg />}
      {type === "Speech Bubble" && <SpeechBubbleSvg />}
      {type === "Tree" && <TreeSvg />}
      {type === "Trophy" && <TrophySvg />}
    </div>
    <H6 children={`Abriofact`} />
    <div
      as="hr"
      css={`
        width: 100%;
        height: 8px;
        margin: 8px 0;
        box-sizing: border-box;
        border: none;
        background-color: ${props => props.theme.colors.text.default};
      `}
    />
    <Text
      children={number}
      fontSize={7}
      color={color}
      css={`
        font-weight: 700;
        line-height: 0.85;
      `}
    />
    <div
      as="hr"
      css={`
        width: 100%;
        height: 4px;
        margin: 16px 0;
        box-sizing: border-box;
        border: none;
        background-color: ${props => props.theme.colors.text.default};
      `}
    />
    <Text
      children={children}
      css={`
        font-weight: 700;
        a {
          text-decoration: underline;
        }
      `}
    />
  </Wrapper>
);

export default AbrioFact;
